// role_code, display name
// const roleCodes = {
//   ADMIN: 'Administrator',
//   USER: 'User',
//   ADVISOR: 'Advisor',
//   P_ACCT_MGR: 'Primary Account Manager',
//   ACCT_MGR: 'Account Manager',
//   CLAIMS: 'Claims',
//   LOSS_CNTRL: 'Loss Control',
// };

// One place for the name to live
const insuredGroupName = 'Policy Holder'
const brokerageGroupName = 'Brokerage'
const otherGroupName = 'Other'

const groupNames = {
  insuredGroupName,
  brokerageGroupName,
  otherGroupName,
}

const insuredRoles = {
  ADMIN: 'Admin',
  USER: 'User',
}

const brokerage = {
  ADVISOR: 'Advisor',
  P_ACCT_MGR: 'Primary Account Manager',
  ACCT_MGR: 'Account Manager',
  CLAIMS: 'Claims',
  LOSS_CNTRL: 'Loss Control',
}

const carrierRoles = {
  INSRNC_PTR: 'Insurance Partner',
}

const roleCodes = {
  ...insuredRoles,
  ...brokerage,
  ...carrierRoles,
}

const brokerageRoles = Object.keys(brokerage)
const insuredRolesList = Object.keys(insuredRoles)

export { groupNames, roleCodes, insuredRoles, insuredRolesList, brokerage, brokerageRoles, carrierRoles }
